import { EventEmitter, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class EventMenuProfileService {
  public $eventMenu = new EventEmitter();
  public $showProfile = new EventEmitter<boolean>(false);
  public $eventCloseSesionFromOutsideMenu = new EventEmitter();
  public $eventNewPicture = new EventEmitter<string>();
  public $eventNewProfile = new EventEmitter();
  public $eventHideNotiCashier = new EventEmitter();
  public $eventHideNotiBonus = new EventEmitter();
  public $eventLogin = new EventEmitter();
  public $closingSession = new EventEmitter();
  public isPCPlayer: boolean = true;
  
  
  constructor() {}
  toggleMenu() {
    this.$eventMenu.emit();
  }

  closeSesion(){
    this.$eventCloseSesionFromOutsideMenu.emit();
  }

  emitNewPictureEvent(urlPicture: string){
    this.$eventNewPicture.emit(urlPicture);
  }

  emitSavingUser(){
    this.$eventNewProfile.emit();
  }

  showProfile(){
    this.$showProfile.emit(true);;
  }

  hideNotiCashier(){
    this.$eventHideNotiCashier.emit();
  }

  hideNotiBonus(){
    this.$eventHideNotiBonus.emit();
  }

  login(){
    this.$eventLogin.emit();
  }

  closingSession(value: boolean){
    this.$closingSession.emit(value);
  }

  toggleIsPCPlayer(value: boolean) {
    this.isPCPlayer = value
  }
}
